import * as React from "react";
function SvgPauseFat(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M34 40c-2.21 0-4-1.79-4-4V12c0-2.21 1.79-4 4-4s4 1.79 4 4v24c0 2.21-1.79 4-4 4zm-16-4V12c0-2.21-1.79-4-4-4s-4 1.79-4 4v24c0 2.21 1.79 4 4 4s4-1.79 4-4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPauseFat);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
